import { Wifi, Plug, Armchair, Car } from "lucide-react";
import { CERTIFIED_SCORE_THRESHOLD } from "@/lib/certification";

const PILLARS = [
  {
    icon: Wifi,
    label: "Wi-Fi",
    blurb: "Reliable, free Wi-Fi earns the highest grade.",
  },
  {
    icon: Plug,
    label: "Outlets",
    blurb: "The easier it is to find a plug, the better the grade.",
  },
  {
    icon: Armchair,
    label: "Seating",
    blurb: "Comfort and elbow room for a long session.",
  },
  {
    icon: Car,
    label: "Parking",
    blurb: "Free lots grade highest; metered spots grade lowest.",
  },
];

export function ScoreExplainer() {
  return (
    <section className="rounded-2xl border border-border bg-card p-6 sm:p-8">
      <h2 className="font-serif text-2xl font-semibold text-foreground sm:text-3xl">
        How the Grounded Score works
      </h2>
      <p className="mt-2 text-base leading-relaxed text-muted-foreground">
        Every café gets a score from 0–100 based on the four things that actually
        matter when you're trying to get work done. Each one is graded A through F.
      </p>
      <ul className="mt-6 grid gap-4 sm:grid-cols-2">
        {PILLARS.map((p) => (
          <li key={p.label} className="flex items-start gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[hsl(var(--seal-gold)/0.15)] text-[hsl(var(--primary))]">
              <p.icon className="h-5 w-5" />
            </div>
            <div>
              <span className="font-medium text-foreground">{p.label}</span>
              <p className="text-sm text-muted-foreground">{p.blurb}</p>
            </div>
          </li>
        ))}
      </ul>
      <p className="mt-6 text-sm leading-relaxed text-muted-foreground">
        Cafés scoring {CERTIFIED_SCORE_THRESHOLD} or higher are Grounded Certified — the spots we'd
        confidently send you to for a full work session.
      </p>
    </section>
  );
}
